import styled from '@emotion/styled';
import { Button, Image, Spin } from 'antd';
import { useState } from 'react';
import stop from '../../../assets/images/stop.png';
import logo from '../../../assets/images/welcome.png';
import { ORANGE, PRIMARY } from '../../../shared/colors';

const InfoContainer = styled.div`
  width: min(100%, 520px);
  padding: 28px;
  overflow: hidden;
  border-radius: 24px;
  background-color: #fff;
  box-shadow: 0 18px 40px rgba(20, 20, 20, 0.14);

  .text-center {
    text-align: center;
  }

  h1 {
    margin-bottom: 12px;
    font-size: 26px;
  }

  h2 {
    margin-bottom: 16px;
    font-size: 22px;
    line-height: 1.35;
  }

  .text-description {
    font-size: 16px;
    line-height: 1.6;
    color: #5f6368;
    margin-bottom: 20px;
  }

  .resend-link {
    font-size: 14px;

    p {
      text-decoration: underline;
      color: #1890ff;
      cursor: pointer;
    }
  }

  .top-line {
    background-color: ${PRIMARY};
    height: 5px;
    width: calc(100% + 56px);
    margin: -28px -28px 24px;
  }

  .message-visual,
  .message-action,
  .message-description {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }

  .ant-btn-primary {
    min-width: 160px;
    background-color: ${ORANGE};
    border: 0;
  }

  @media (max-width: 767px) {
    padding: 22px 18px;
    border-radius: 20px;

    .top-line {
      width: calc(100% + 36px);
      margin: -22px -18px 22px;
    }

    h1 {
      font-size: 23px;
    }

    h2 {
      font-size: 19px;
    }

    .text-description {
      font-size: 14px;
    }
  }
`;
export const MessageContainer = ({
  title,
  description,
  showError,
  onClick,
}: {
  title: string;
  description?: string;
  showError?: boolean;
  onClick?: () => void;
}) => {
  // const router = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  // const companyCode = router.location.query.companyCode as string;

  return (
    <InfoContainer>
      <div className='top-line'></div>
      <div className='message-visual'>
        {!showError && <h1 className='text-center'>Félicitations</h1>}
        <Image
          alt='felicitation'
          src={showError ? stop : logo}
          width={200}
          height={100}
          style={{ objectFit: 'contain' }}
          preview={false}
        />
      </div>
      <h2 className='text-center'>{title} </h2>
      {description && (
        <div className='message-description'>
          <h3 className='text-center text-description'>{description}</h3>
          <h3 className='text-center resend-link'>
            Si vous n’avez pas reçu de mail d’ici 2 mins
            <span style={{ color: '#f44336' }}>(vérifiez vos spams)</span>,
            <br />
            <p
              onClick={async () => {
                setIsLoading(true);
                // await resendValidationEmail(company as CompanyEntity);
                setIsLoading(false);
              }}
            >
              cliquez ici pour envoyer un nouveau lien de vérification par email
            </p>
          </h3>
          <Spin spinning={isLoading} />
        </div>
      )}
      {onClick && (
        <div className='message-action'>
          <Button
            type='primary'
            onClick={onClick}
            size='large'
          >
            Continuer
          </Button>
        </div>
      )}
    </InfoContainer>
  );
};
